import React, { Fragment } from 'react'
import VisitasListItemComponent from './VisitaListItemComponent'
import estilos from './VisitasListComponent.module.css'

const VisitasListComponent = (props) => {

  const [consulta, setConsulta] = React.useState('');

  const visitasDelDia = [
    {
      id: '0001', razonSocial: 'Mezcal Oro de Oaxaca',
      domicilio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde, quae sint minus explicabo repellat',
      statusDeLaVisita: 1, fechaVisita: '13/05/2022'
    },
    {
      id: '0002', razonSocial: 'Mezcal Tobalá', domicilio: 'Lorem ipsum dolor sit amet consectetur adipisicing elitm doloremque!',
      statusDeLaVisita: 2, fechaVisita: '13/05/2022'
    },
    {
      id: '0003', razonSocial: 'Fabrica de Mezcal',
      domicilio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.  Distinctio eos facere cum doloremque!',
      statusDeLaVisita: 3, fechaVisita: '13/05/2022'
    },
    {
      id: '0004', razonSocial: 'Mezcal Coyote',
      domicilio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio eos facere cum doloremque!',
      statusDeLaVisita: 4, fechaVisita: '13/05/2022'
    },
    {
      id: '0005', razonSocial: 'Mezcal Jabalis',
      domicilio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.  Distinctio eos facere cum doloremque!',
      statusDeLaVisita: 5, fechaVisita: '13/05/2022'
    },
  ]

  const siCoincideConLaConsultaEntoncesRenderizate = (visita,index) => {
    let content = [];
    let auxConsulta = consulta.toLowerCase();
    //console.log(visita.razonSocial+' includes '+auxConsulta +': '+ visita.razonSocial.includes(auxConsulta))
    if (visita.razonSocial.toLowerCase().includes(auxConsulta) || visita.id.toLowerCase().includes(auxConsulta) ){
        content.push(<VisitasListItemComponent key={index}
        visita={visita}
        statusDeLaVisita={visita.statusDeLaVisita}
        domicilio={visita.domicilio}
        nombreEmpresa={visita.razonSocial}
        diaVisita={props.dia}
        mes={props.mes}
      ></VisitasListItemComponent>);
    }
    
    return content;

  }

  return (
    <Fragment>

      <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5'>
        <input className='form-control' placeholder='Buscar por número de Socio o por razón social' onChange={e => setConsulta(e.target.value)}></input>
        <table className="table">
          <thead>
            <tr>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              visitasDelDia.map((visita, index) => (
                siCoincideConLaConsultaEntoncesRenderizate(visita,index)
              ))
            }

          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default VisitasListComponent